import GoogleMapContainer from "../../Componant/Maps/GoogleMap";

const GoogleMap = () => {
  return (
    <div className="page-body">
      <GoogleMapContainer />
    </div>
  );
};

export default GoogleMap;
